"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MessageSquareFilledIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 2.116C0 1.5.512 1 1.143 1h13.714C15.488 1 16 1.5 16 2.116v7.812c0 .616-.512 1.116-1.143 1.116H5.714c-.853 0-3.298 1.865-4.72 2.811-.522.347-.994.037-.994-.58V2.117z"
  })))
});
MessageSquareFilledIcon.displayName = 'MessageSquareFilledIcon';
var _default = exports.default = MessageSquareFilledIcon;